import type { ChometzSubmission } from "@/Domain/ChometzSubmission";
import { EnumChometzSaleOption } from "@/Domain/EnumChometzSaleOption";

export const getSubmissionTypeString = function (
  submission: ChometzSubmission
) {
  if (submission.NoChometz) return "";
  switch (submission.SubmissionType) {
    case EnumChometzSaleOption.OUSale:
      return !submission.SubmittedDate ||
        new Date(submission.SubmittedDate).getFullYear() >= 2024
        ? "Rabbi Nachum Rabinowitz (OU)"
        : "Rabbi Luban (OU)";
    case EnumChometzSaleOption.NonOUSale:
      return submission.ChometzSoldBy;
    default:
      return "";
  }
};

// Check if the two submissions are different based on visible fields
// Also check if the second submission has any visible value
export const isDifferent = function (
  submission1: ChometzSubmission,
  submission2: ChometzSubmission,
  fields: (keyof ChometzSubmission)[]
) {
  let hasAnyVisibleValue = false;
  let different = false;
  for (const field of fields) {
    if (submission2[field]) hasAnyVisibleValue = true;
    if (!submission1 || submission1[field] !== submission2[field])
      different = true;

    if (hasAnyVisibleValue && different) return true;
  }
  return false;
};
